import { motion } from 'framer-motion';
import { useRouter } from 'next/router';
import { ReactNode, useEffect, useRef, useState } from 'react';

import styles from './page-transition.module.css';

interface PageTransitionProps {
    children: ReactNode;
}

export function PageTransition({ children }: PageTransitionProps) {
    const { pathname } = useRouter();
    const [animKey, setAnimKey] = useState<string | null>(null);
    const prevPathname = useRef(pathname);

    useEffect(() => {
        if (pathname !== prevPathname.current) {
            prevPathname.current = pathname;
            setAnimKey(pathname);
        }
    }, [pathname]);

    return (
        <motion.div
            key={animKey ?? 'static'}
            className={styles['page-transition']}
            initial={animKey !== null ? { opacity: 0 } : false}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
        >
            {children}
        </motion.div>
    );
}
